import { AuthProvider, hasAuthParams } from '@dhxete/auth-provider'
import 'core-js/stable'
import 'element-remove'
import 'proxy-polyfill'
import React from 'react'
import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import ReactDOM from 'react-dom'
import 'regenerator-runtime/runtime'
import authConfig from './auth'
import App from './lib/App/App'

// When we are getting a callback from the authentication server,
// we render a minimal empty page that will redirect to the original widget conatiner app.
const onRedirectCallback = (appState) => {
  if (appState?.returnTo) {
    console.log('[CM] Resuming After Authentication', appState)
    window.location.replace(appState.returnTo)
  } else {
    window.location.replace(
      `${window.location.origin}/${window.location.pathname}`,
    )
  }
}

if (hasAuthParams(window.location.search)) {
  // Here we are getting a callback from the authentication server
  // and will use appState to redirect back to the original widget container app.
  // Nothing is rendered on the page.
  ReactDOM.render(
    <AuthProvider {...authConfig} onRedirectCallback={onRedirectCallback} />,
    document.getElementById('root'),
  )
} else {
  // Here we are loading as normal
  ReactDOM.render(
    <React.StrictMode>
      <AuthProvider {...authConfig} skipRedirectCallback={false}>
        <App />
      </AuthProvider>
    </React.StrictMode>,
    document.getElementById('root'),
  )
}
